import React from 'react';
import { GPSStatusType } from '../types';

interface GPSStatusProps {
  status: GPSStatusType;
  accuracy: number | null;
}

export const GPSStatus: React.FC<GPSStatusProps> = ({ status, accuracy }) => {
  let dotColor = 'bg-slate-500';
  let label = 'GPS IDLE';

  switch (status) {
    case 'ready':
      dotColor = 'bg-emerald-400 shadow-[0_0_8px_rgba(52,211,153,0.8)] animate-pulse';
      label = accuracy ? `GPS READY (${Math.round(accuracy)}m)` : 'GPS READY';
      break;
    case 'searching':
      dotColor = 'bg-amber-400 shadow-[0_0_8px_rgba(251,191,36,0.8)] animate-pulse';
      label = 'GPS SEARCHING';
      break;
    case 'signal_weak':
      dotColor = 'bg-amber-500';
      label = accuracy ? `GPS WEAK (${Math.round(accuracy)}m)` : 'GPS WEAK';
      break;
    case 'denied':
      dotColor = 'bg-rose-500';
      label = 'GPS DENIED';
      break;
    case 'unavailable':
      dotColor = 'bg-rose-500';
      label = 'GPS UNAVAILABLE';
      break;
    case 'demo':
      dotColor = 'bg-cyan-400 shadow-[0_0_8px_rgba(6,182,212,0.8)]';
      label = 'DEMO MODE';
      break;
    default:
      dotColor = 'bg-slate-500';
      label = 'GPS STANDBY';
  }

  return (
    <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-900/80 border border-slate-800 text-[11px] font-bold tracking-widest text-slate-300 select-none">
      <span className={`w-2 h-2 rounded-full ${dotColor}`} />
      <span>{label}</span>
    </div>
  );
};
